import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "modal auto_adjust popup publicSignIn" }
const _hoisted_2 = { class: "modal--content min--width--30" }
const _hoisted_3 = {
  key: 0,
  class: "modal--header"
}
const _hoisted_4 = { class: "modal--body signInContainer" }
const _hoisted_5 = {
  key: 1,
  class: "avatar-container"
}
const _hoisted_6 = { class: "userName" }
const _hoisted_7 = { class: "userHanlde" }
const _hoisted_8 = { class: "text-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconComponent = _resolveComponent("IconComponent")!
  const _component_ProfileAvatarComponent = _resolveComponent("ProfileAvatarComponent")!
  const _component_SignInComponent = _resolveComponent("SignInComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "modal--backdrop",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dismiss(false)))
    }),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.showPublicSignInForm)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_IconComponent, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dismiss(false))),
              class: "newHeadericon",
              icon: "close-times.svg"
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        (!_ctx.showPublicSignInForm)
          ? (_openBlock(), _createBlock(_component_IconComponent, {
              key: 0,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dismiss(false))),
              class: "newHeadericon",
              icon: "close-times.svg"
            }))
          : _createCommentVNode("", true),
        (!_ctx.showPublicSignInForm)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_ctx.images.profilePicture)
                ? (_openBlock(), _createBlock(_component_ProfileAvatarComponent, {
                    class: "semilarge",
                    key: _ctx.images.profilePicture,
                    profileImage: _ctx.images.profilePicture,
                    badges: false,
                    camera: false,
                    redirectProfile: false
                  }, null, 8, ["profileImage"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", null, [
                _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.userData?.fullName), 1),
                _createElementVNode("p", _hoisted_7, "@" + _toDisplayString(_ctx.userData?.userName), 1)
              ]),
              _createElementVNode("p", _hoisted_8, "Join to View " + _toDisplayString(_ctx.firstName) + "'s Full Profile", 1)
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_SignInComponent, {
          openExistingUser: true,
          isPublicSignIn: !_ctx.fromHeader ? true : false,
          onShowForm: _ctx.toggleSignInForm,
          fromPostDetail: _ctx.fromPostDetail,
          postData: _ctx.postData,
          fromCrox: _ctx.fromCrox
        }, null, 8, ["isPublicSignIn", "onShowForm", "fromPostDetail", "postData", "fromCrox"])
      ])
    ])
  ]))
}